import React from "react";
import { Link } from "react-router-dom";

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-white text-black font-sans">

      {/* Prevent navbar overlap */}
      <div className="max-w-4xl mx-auto px-4 pt-28 pb-16">

        {/* Header Section */}
        <div className="mb-10 border-b border-gray-300 pb-6">
          
          {/* Breadcrumb */}
          <nav className="text-sm font-medium mb-3">
            <Link to="/" className="text-orange-600 hover:text-orange-700">
              Home
            </Link>
            <span className="mx-2 text-gray-500">/</span>
            <span className="text-gray-700">Privacy Policy</span>
          </nav>

          <h1 className="text-3xl md:text-4xl font-black mb-2">
            Privacy Policy
          </h1>

          <p className="text-sm text-gray-600">
            VIDYAZON (Vidyazon - A Division of admitere educational services private limited)
          </p>
        </div>

        {/* CONTENT SECTION */}
        <div className="space-y-8 text-sm md:text-base leading-relaxed">
          
          {/* INTRO */}
          <p>
            We, <strong>Vidyazon - A Division of admitere educational services private limited</strong> ("Vidyazon", “we”, “us”, or “our”), 
            are committed to protecting the privacy and security of your personal 
            information. Your privacy is extremely important to us, and maintaining 
            your trust is our highest priority.
          </p>

          <p>
            This Privacy Policy explains how we collect, store, use, and disclose 
            your information when you access our website, mobile app, or any 
            related platform or service offered by Vidyazon. By using our services, 
            you agree to be bound by this Privacy Policy along with our Terms of Use.
          </p>

          <p>
            This policy applies to all Vidyazon-operated services but does not apply 
            to third-party platforms that maintain independent privacy policies. 
            We recommend reviewing their policies when interacting with them.
          </p>

          <p>
            If you have any questions or clarifications regarding this Privacy Policy, 
            please write to us at <strong>info@vidyazon.com</strong>.
          </p>

          {/* COLLECTION OF INFORMATION */}
          <section>
            <h2 className="text-xl font-bold mb-3">
              Collection, Storage & Use of Your Information
            </h2>

            <p>
              We may automatically store certain information including details 
              such as your:
            </p>

            <ul className="list-disc pl-5 mt-2 space-y-1 text-gray-700">
              <li>Web browser type and version</li>
              <li>IP address</li>
              <li>Device details</li>
              <li>Cookies stored on your device</li>
              <li>Pages visited and interactions on our website</li>
            </ul>

            <p className="mt-3">
              This information helps us analyze user behavior, understand 
              demographics, and improve user experience.
            </p>

            <p className="mt-4">We also collect personal data voluntarily provided by you such as:</p>

            <ul className="list-disc pl-5 mt-2 space-y-1 text-gray-700">
              <li>Name, email, and contact number</li>
              <li>Location and address</li>
              <li>Uploaded documents (if any)</li>
              <li>Payment information (processed securely through gateways)</li>
            </ul>

            <p className="mt-4">We use this information to:</p>

            <ul className="list-disc pl-5 mt-2 space-y-1 text-gray-700">
              <li>Provide and improve our services</li>
              <li>Communicate service updates and notifications</li>
              <li>Detect and prevent fraud</li>
              <li>Comply with legal obligations</li>
              <li>Offer personalized recommendations</li>
              <li>Send promotional offers (optional)</li>
            </ul>

            <p className="mt-4">
              When a service involves a third-party provider (such as payment gateways 
              or partner institutions), Vidyazon may share only the necessary data required 
              to fulfill the service request.
            </p>

          </section>

          {/* PERMISSIONS */}
          <section>
            <h2 className="text-xl font-bold mb-3">Permissions Used</h2>

            <p>Our mobile app may request the following permissions:</p>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4 text-sm">
              <div className="p-4 rounded bg-gray-100">
                <strong>Contacts:</strong> To invite contacts or share referral codes.
              </div>
              <div className="p-4 rounded bg-gray-100">
                <strong>Location:</strong> For personalized content and services.
              </div>
              <div className="p-4 rounded bg-gray-100">
                <strong>SMS:</strong> To auto-read OTP for login/payment.
              </div>
              <div className="p-4 rounded bg-gray-100">
                <strong>Phone:</strong> To make direct customer support calls.
              </div>
              <div className="p-4 rounded bg-gray-100">
                <strong>Camera/Media:</strong> To upload documents/photos.
              </div>
              <div className="p-4 rounded bg-gray-100">
                <strong>Device Info:</strong> To optimize performance and compatibility.
              </div>
            </div>
          </section>

          {/* COOKIES */}
          <section>
            <h2 className="text-xl font-bold mb-3">Cookies</h2>
            <p>
              Vidyazon uses cookies to analyze activity, enhance performance, 
              improve login experience, and personalize your interaction with the platform.
              You may choose to disable cookies in your browser, but certain features 
              may not function properly.
            </p>
          </section>

          {/* SECURITY */}
          <section>
            <h2 className="text-xl font-bold mb-3">Security & Protection of Information</h2>
            <p>
              We use industry-standard security measures including encrypted transactions, 
              secure servers, and restricted access to protect your information.  
            </p>
            <p className="mt-2">
              However, no method of transmission over the internet is 100% secure. 
              Vidyazon will not be liable for unauthorized access due to factors beyond 
              our control.
            </p>
          </section>

          {/* CHANGES */}
          <section>
            <h2 className="text-xl font-bold mb-3">Changes to This Privacy Policy</h2>
            <p>
              Vidyazon reserves the right to update this Privacy Policy at any time. 
              Changes are effective immediately upon being posted on our website/app. 
              You are encouraged to review this page periodically.
            </p>
          </section>

          {/* GRIEVANCE REDRESSAL */}
          <section className="bg-blue-50 p-6 rounded-xl border border-blue-200">
            <h2 className="text-xl font-bold text-blue-800 mb-3">
              Grievance Redressal
            </h2>

            <p className="mb-4">
              If you have any concerns or grievances regarding this Privacy Policy, 
              please contact:
            </p>

            <address className="not-italic">
              <strong>Vidyazon - A Division of admitere educational services private limited</strong><br />
              (Global Office, New Delhi)<br /><br />
              <strong>Phone:</strong> +91 9997517305<br />
              <strong>Email:</strong> info@vidyazon.com
            </address>
          </section>

        </div>
      </div>
    </div>
  );
}
